import { HttpClient, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, catchError, map, of, tap } from "rxjs";
import { environment } from "../../environments/environment";
import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';
import { LocalStorageService } from "./localStorage.service";


@Injectable({
  providedIn: "root",
})
export class AuthService {
  url = `${environment.apiUrl}`;
  authUrl = `${environment.authUrl}`;

  constructor(
    private http: HttpClient,
    private localStorageService: LocalStorageService,
  ) {}

  /*==============================
  New Password
  ================================*/
  newPassword(
    email: string,
    token: string,
    password: string,
    passwordConfirmation: string
  ) {}

  /*==============================
  Login User
  ================================*/
  getToken() {}

  /*==============================
  getIsAuth
  ================================*/
  getIsAuth() {}

  /*==============================
  logout
  ================================*/
  logout(): Observable<HttpResponse<unknown>> {
    if (!this.localStorageService.isAuth()) {
      return of(new HttpResponse({ status: 204, body: null }));
    }
    return this.http.post(`${this.authUrl}/frontoffice/logout`, null, {
      observe: "response",
    });
  }

  /*==============================
  saveAuthData
  ================================*/
  private saveAuthData(token: string, client: any) {
    localStorage.setItem("token", token);
    localStorage.setItem("id", client.id);
    localStorage.setItem("model_id", client.model_id);
    localStorage.setItem("user_id", client.user_id);
  }

  private handleError<T>(operation = "operation", result?: T) {
    return (error: any): Observable<T> => {
      return of(result as T);
    };
  }

  /*==============================
  create user
  ================================*/
  createUser(formData: any) {
    return this.http.post(`${this.url}/frontoffice/register`, formData, {
      observe: "response",
    });
  }

  /*==============================
  Login
  ================================*/
  login(formData: any) {
    return this.http.post(`${this.url}/frontoffice/login`, formData, {
      observe: "response",
    });
  }

  /*==============================
  forgot Password
  ================================*/
  forgotPassword(email: any) {
    return this.http.post(
      `${this.url}/frontoffice/forgot-password-otp`,
      email,
      { observe: "response" }
    );
  }

  /*==============================
  verifier reset password code
  ================================*/
  verifCode(formdata: any):Observable<any> {
    return this.http.post(`${this.url}/frontoffice/verifier-otp`, formdata, {
      observe: "response",
    });
  }
  /*==============================
  Reset Password
  ================================*/
  resetPassword(formdata: any) {
    return this.http
      .post(`${this.url}/frontoffice/reset-password-otp`, formdata, {
        observe: "response",
      })
      .pipe(catchError(this.handleError<HttpResponse<any>>("Reset password")));
  }

  /*==============================
  Delete Account
  ================================*/
  deleteAccount(payload: any) {

    return this.http.delete(`${this.authUrl}/frontoffice/delete-account`, {
      params: payload,
      observe: "response",
    });
  }

  /*==============================
  Desactivate Account
  ================================*/
  desactivateAccount(payload: any) {
    return this.http.post(
      `${this.authUrl}/frontoffice/deactivate-account`,
      payload,
      { observe: "response" }
    );
  }
  /*==============================
  Check if email used
  ================================*/
  checkEmailUsed(data: any) {
    return this.http.post(`${this.url}/frontoffice/check-email`, data.email, {
      observe: "response",
    });
  }

  /*==============================
  update user
  ================================*/
  updateUser(form: any) {
    return this.http.put(`${this.authUrl}/frontoffice/edit-profile`, form, {
      observe: "response",
    });
  }
  updateUserImage(form: any) {
    return this.http.post(
      `${this.authUrl}/frontoffice/change-profile-image`,
      form,
      { observe: "response" }
    );
  }
  updatePassword(form: any) {
    return this.http.put(`${this.authUrl}/frontoffice/change-password`, form, {
      observe: "response",
    });
  }
  refreshToken(): Observable<any> {
    return this.http.get(`${this.url}/frontoffice/refresh-token`).pipe(
      map((response: any) => {
        const accessToken = response?.access_token;
        const refresh = response?.refresh_token;
        if (!accessToken || !refresh) {
          throw new Error("Invalid refresh response");
        }
        localStorage.setItem("token", accessToken);
        localStorage.setItem("refresh", refresh);
        return response;
      })
    );
  }
  getCompletetion(role: string){
    if(role === 'client' || role === 'particulier'){
      return this.http.get(`${this.url}/auth/frontoffice/user/profile-completion-client`, {
        observe: "response",
      });
    } else{
      return this.http.get(`${this.url}/auth/frontoffice/user/profile-completion-provider`, {
        observe: "response",
      });
    }
  }
  updateProfilePart2(form: any) {
    return this.http.post(
      `${this.authUrl}/frontoffice/change-societe-profile`,
      form,
      { observe: "response" }
    );
  }
  updateProfilePart3(form: any) {
    return this.http.post(
      `${this.authUrl}/frontoffice/change-document-profile`,
      form,
      { observe: "response" }
    );
  }
  updateProfileAddDocuments(form: any) {
    return this.http.post(
      `${this.authUrl}/frontoffice/documents`,
      form,
      { observe: "response" }
    );
  }
  updateProfileDeleteDocuments(form: any) {
    return this.http.delete(
      `${this.authUrl}/frontoffice/documents`,
      {
        params: form,
        observe: "response"
      }
    );
  }
    loginBySocial(provider: string, params : any) {
        return this.http.post(`${this.url}/frontoffice/login-${provider}`, params, {
            observe: "response",
        });
    }
    async loadAccounts() {
      try{
        const result = await SecureStoragePlugin.get({ key: 'accounts' });
        return result?.value ? JSON.parse(result.value) : [];
      }
      catch(error){
        return [];
      }    
    }
    
    async addAccount(
      email: string,
      password: string,
      image: string,
      firstname: string,
      lastname: string
    ) {
      const accounts = await this.loadAccounts();
    
      // Check if account already exists by email
      const index = accounts.findIndex((acc: any) => acc.email === email);
    
      if (index !== -1) {
        // Replace existing account
        accounts[index] = { email, password, image, firstname, lastname };
      } else {
        // Add new account
        accounts.push({ email, password, image, firstname, lastname });
      }
    
      await this.saveAccounts(accounts);
    }
    
    async saveAccounts(accounts: { email: string, password: string, image: string, firstname: string, lastname: string }[]) {
      await SecureStoragePlugin.set({
        key: 'accounts',
        value: JSON.stringify(accounts)
      });
    }
  
    async deleteSavedAccount(email: string) {
      const accounts = await this.loadAccounts();
    
      const updatedAccounts = accounts.filter((acc: any) => acc.email !== email);
    
      await this.saveAccounts(updatedAccounts);
    }

  /*==============================
  Send CGV Email to Provider
  ================================*/
  sendCGVEmail(email: string) {
    return this.http.post(
      `${this.url}/frontoffice/send-cgv-email`,
      { email },
      { observe: "response" }
    );
  }
  
}
